<template>
  <div class="mod-config" style="height: 100%">
    <p class="listP">更新日志</p>
    <div style="height: calc(100% - 70px);overflow-y: scroll;">
      <el-collapse  @change="handleChange" :value="opened">
        <el-collapse-item  style="text-align: left" v-for="(item,index) in dataList" :key="item.id" :name="item.id">
          <template slot="title">{{'V'+item.version+'版本更新日志'}} ——{{item.recordDate.substr(0,10)}}</template>
          <span v-html="cutout(item.content)" style="white-space: pre-wrap;font-size: 16px;padding-top: 10px;display: inline-block;"></span>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<style scoped>
  .listP{
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #bbb;
  }
  /deep/ .el-collapse-item__header {
    font-size: 25px;
    border-bottom: 1px solid #bbb;
  }
</style>
<script>
export default {
  data() {
    return {
      dataList:[],
      jjj:''
    }
  },
  computed: {

    opened() {
      this.resourceId = this.$route.query.id;
      console.log(this.resourceId);
      return this.resourceId;
    }
  },
  created() {
    this.getDataList();

  },
  methods: {
    handleChange(val) {
      // console.log(val);
    },
    getDataList() {
      this.$http({
        url: this.$http.adornUrl('/versionsLog/list'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.dataList = data.data.updateLogList
        }
      })
    },
    // 截取数据
    cutout(cellValue) {
      return cellValue.replace(/\\,/g, '</br>')

   }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/helpcenter/updateLog.vue